$(document).on('submit', 'form[method=get][data-remote!=true]', function(e) {
  e.preventDefault();
  const form = $(this);
  Turbolinks.visit(form.attr("action") + '?' + form.serialize());
});